import { render, staticRenderFns } from "./ads-overview.vue?vue&type=template&id=90b0218a&"
import script from "./ads-overview.vue?vue&type=script&lang=js&"
export * from "./ads-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports